export class AgentCertificate {
    Id:string;
    URL: string;
    ExpirationDate: Date;
    CertificateType:number;
    NameEN: string;
    NameAR:string;
    Size:number;
    
}
